
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'

@Component({
  name: 'App'
})
export default class extends Vue {
  @Watch('$route')
  onRouteChange(route: Route) {
    if (route.path !== '/login' && route.path !== '/') {
      const loader = document.querySelector('.Loader-container')
      if (loader) {
        loader.setAttribute('style', 'display: none;')
      }
    }
  }
}
